// Layer mutators — pure (state, args) => patch.

export function updateLayer(state, { id, patch }) {
  if (!state.layers.some((l) => l.id === id)) return null;
  return { layers: state.layers.map((l) => (l.id === id ? { ...l, ...patch } : l)) };
}

// `id` generated by the caller (not deterministic).
export function addLayer(state, { id, name = 'New layer' }) {
  return { layers: [...state.layers, { id, name, opacity: 1, visible: true }] };
}

// Deleting a layer detaches its elements (they keep rendering, unlayered).
export function deleteLayer(state, { id }) {
  if (!state.layers.some((l) => l.id === id)) return null;
  return {
    layers: state.layers.filter((l) => l.id !== id),
    elements: state.elements.map((el) => (el.data?.layer === id ? { ...el, data: { ...el.data, layer: null } } : el)),
  };
}

// Reorder to the given id order; unknown ids are dropped, missing ids keep the
// old order intact (no-op) so a stale DOM read can't lose layers.
export function reorderLayers(state, { ids }) {
  const byId = new Map(state.layers.map((l) => [l.id, l]));
  const next = ids.map((id) => byId.get(id)).filter(Boolean);
  if (next.length !== state.layers.length) return null;
  if (next.every((l, i) => l === state.layers[i])) return null;
  return { layers: next };
}
